import { useEffect } from 'react'

export const useLegality = () => {
 



  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])
}
